import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    aboutESimModalContainer: {
        padding: theme.spacing(4, 0),
    },
    aboutESimContent: {
        marginTop: theme.spacing(4),
    },
    aboutESimText: {
        marginTop: theme.spacing(2),
    },
    aboutESimItem: {
        textAlign: "center",
        marginBottom: theme.spacing(2),
    },
}));
